import { Injectable, inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateFn,
} from "@angular/router";
import { AuthService } from "../authentication/services/auth.service";
import { Observable, of } from "rxjs";
import { catchError, filter, map, take, timeout } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class AuthIsLoadingGuardService {
  private auth = inject(AuthService);

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.auth.isLoading$.pipe(
      filter((isLoading) => !isLoading),
      take(1),
      timeout(5000), // 5 seconds
      map(() => true),
      catchError(() => of(false))
    );
  }
}

export const AuthIsLoadingGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> => {
  return inject(AuthIsLoadingGuardService).canActivate(next, state);
};
